// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBlS-mASQ9u9M_H7X3iF8urHtCXpYrW-Dk",
  authDomain: "ginaex-f2b97.firebaseapp.com",
  projectId: "ginaex-f2b97",
  storageBucket: "ginaex-f2b97.appspot.com",
  messagingSenderId: "627407269083",
  appId: "1:627407269083:web:46f70dd6562ac5530ff0fe",
  measurementId: "G-QW9VKL0XFK",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default app;
